import { PrivateAPINamespace } from '../PrivateAPINamespace';
export class ExperimentsNamespace extends PrivateAPINamespace {
    getValue(key) {
        return this.ps.experimentsAPI.getValue(key);
    }
    enabled(key) {
        return this.ps.experimentsAPI.enabled(key);
    }
    all() {
        return this.ps.experimentsAPI.all();
    }
}
ExperimentsNamespace.namespace = 'experiments';
//# sourceMappingURL=ExperimentsNamespace.js.map